export default __webpack_public_path__ + "static/screenshot-catalog-e3ceffdbd32916e02e5efeed3368a603.png";